import BaseService from "../base";
import {keycloak} from "../../keycloak/keycloak";

const apiService = new BaseService(process.env.REACT_APP_VISUALS_API_URL + '/v1/customers', {});


export async function searchCustomers(params) {
    if (keycloak.authenticated) {
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`,
            'Accept': 'application/json'
        }
        return await apiService.get('/search', params, {headers: headers})
            .then(result => {
                return result.data
            })
            .catch(reason => {
                throw reason
            })
    }
    throw new Error('You are not authenticated')
}

export async function createCustomer(data) {
    if (keycloak.authenticated) {
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`,
            'Accept': 'application/json'
        }
        return await apiService.post('', data, {headers: headers})
            .then(result => {
                return result.data
            })
            .catch(reason => {
                throw reason
            })
    }
    throw new Error('You are not authenticated')
}


export async function getCustomer(id) {
    if (keycloak.authenticated) {
        let headers = {
            'Authorization': `Bearer ${keycloak.token}`,
            'Accept': 'application/json'
        }
        return await apiService.get(`/${id}`, {}, {headers: headers})
            .then(result => {
                return result.data
            })
            .catch(reason => {
                throw reason
            })
    }
    throw new Error('You are not authenticated')
}

export async function updateCustomer(data) {
    if (keycloak.authenticated) {
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`,
            'Accept': 'application/json'
        }
        return await apiService.patch(`/${data.id}`, data, {headers: headers})
            .then(result => {
                return result.data
            })
            .catch(reason => {
                throw reason
            })
    }
    throw new Error('You are not authenticated')
}


export async function deleteCustomer(id) {
    if (keycloak.authenticated) {
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`,
            'Accept': 'application/json'
        }
        return await apiService.delete(`/${id}`,{headers:headers});
    }
    throw new Error('You are not authenticated')
}

